import React from "react";
import RestrictedWebhookOptionWrapper from "../../RestrictedWebhookOptionWrapper";
import { SelectedWebhookType } from "../../../enums";
import { AlertTriangle } from "lucide-react";
import WebhookSelectCard from "./WebhookSelectCard";
import IssuesMutedDescription from "./IssuesMutedDescription";

interface LinkedAccountIssuesWebhookProps {
  onSelectedWebhookTypeChange: (selectedWebhookType: SelectedWebhookType) => void;
  selectedWebhookType: Set<SelectedWebhookType>;
  onUnselectingWebhookType: (selectedWebhookType: SelectedWebhookType) => void;
  isEditMode: boolean;
  isIssuesMutedEnabled: boolean;
}

function LinkedAccountIssuesWebhook(props: LinkedAccountIssuesWebhookProps) {
  const {
    onSelectedWebhookTypeChange,
    selectedWebhookType,
    onUnselectingWebhookType,
    isEditMode,
    isIssuesMutedEnabled,
  } = props;
  const selected = selectedWebhookType
    ? selectedWebhookType.has(SelectedWebhookType.ISSUES)
    : false;
  return (
    <RestrictedWebhookOptionWrapper>
      <WebhookSelectCard
        title="Linked Account issues"
        // Only mention muted when the backend actually supports it (otherwise it is not
        // submitted). When it is supported, flag it as new only while editing an existing
        // webhook, since a brand-new webhook has no prior subscription to add to.
        description={
          !isIssuesMutedEnabled ? (
            "Receive an alert when a Linked Account issue is created or resolved."
          ) : isEditMode ? (
            <IssuesMutedDescription />
          ) : (
            "Receive an alert when a Linked Account issue is created, muted, or resolved."
          )
        }
        icon={<AlertTriangle size={16} />}
        onClick={() => {
          if (selected) {
            onUnselectingWebhookType(SelectedWebhookType.ISSUES);
          } else {
            onSelectedWebhookTypeChange(SelectedWebhookType.ISSUES);
          }
        }}
        selected={selected}
        selectedWebhookType={selectedWebhookType}
      />
    </RestrictedWebhookOptionWrapper>
  );
}

export default LinkedAccountIssuesWebhook;
